import { render } from "./ChangePasswordView.vue?vue&type=template&id=e4e15e66&scoped=true"
import script from "./ChangePasswordView.vue?vue&type=script&lang=js"
export * from "./ChangePasswordView.vue?vue&type=script&lang=js"

import "./ChangePasswordView.vue?vue&type=style&index=0&id=e4e15e66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4e15e66"]])

export default __exports__